// extracted by mini-css-extract-plugin
export default {"text-label":"label_text-label__V+O9n","SelectInput":"label_SelectInput__zJaaF","preprocessing-icon":"label_preprocessing-icon__gDO1L"};